<template>
  <div
    class="content-wrapper"
    :class="{'cross-content': !$store.state.sharePresentation && !isBackstage}"
  >
    <div id="word-cloud" class="horizontal layout center-justified" v-if="checkShowContent()" />
    <CanvasQuestionImage
      v-show="slideActive.showQuestionImage && slideActive.image"
      @imageLoaded="isLoading = false"
      :isLoading="isLoading"
    />
  </div>
</template>
<script>
import { setTimeout } from 'timers'
import { mapState, mapActions, mapGetters } from 'vuex'
import filterProfaneWords from 'storybook-utils/profanity-filter/filterProfaneWords'
import CanvasQuestionImage from '@/components-v2/presentation-editor/middle/CanvasQuestionImage.vue'
import EventBus from '@/eventBus'
import Constant from '@/constant'
import Config from '@/config'
import Util from '@/util'
import PresentationUtils from '@/utils/presentation'

const WORD_CLOUD_TRANSITION_DURATION = 600
export default {
  components: {
    CanvasQuestionImage,
  },
  data() {
    return {
      myWordCloud: null,
      isLoading: false,
      debounceWordCloud: null,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    ...mapGetters(['isBackstage']),
  },
  watch: {
    '$store.state.slideActive': function watchSlideActive() {
      setTimeout(() => {
        if (this.$refs['slide-imgg'] && !this.$refs['slide-imgg'].complete) {
          this.isLoading = true
        }
        if (document.getElementById('word-cloud') && !document.getElementById('word-cloud').innerHTML) {
          this.renderWordCloud()
        }
      }, 1)
    },
    '$store.state.slideActive.textColour': function watchTextColour() {
      this.renderWordCloud()
    },
    '$store.state.presentation.filteringProfanity': function watchFilteringProfanity() {
      this.renderWordCloud()
    },
  },
  mounted() {
    const self = this
    setTimeout(() => {
      this.renderWordCloud()
    }, 200)
    EventBus.$on('audienceWordCloud', () => {
      if (self.myWordCloud) {
        if (self.debounceWordCloud) {
          return
        }
        self.debounceWordCloud = setTimeout(() => {
          self.myWordCloud.update(self.getWords())
          clearTimeout(self.debounceWordCloud)
          self.debounceWordCloud = null
        }, 1000)
      }
    })
    if (this.$store.state.sharePresentation) {
      this.updateSlideActiveAction({
        showQuestionImage: false,
      })
    }
  },
  destroyed() {
    EventBus.$off('audienceWordCloud')
    Util.allowPDFRender()
  },

  methods: {
    ...mapActions(['updateSlideActiveAction']),
    checkShowContent() {
      let show = true
      if (this.$store.state.slideActive.showQuestionImage && this.$store.state.slideActive.image) {
        show = false
      } else if (!this.$store.state.slideActive.hideResult) {
        show = true
      } else {
        show = false
      }
      return show
    },
    getWords() {
      let arr = []
      const options = JSON.parse(
        JSON.stringify(this.$store.state.slideActive.SlideOptions),
      )

      options.forEach((item) => {
        if (item.title) {
          item.title = item.title.trim()
          item.title = item.title.toLowerCase()
          if (item.title.length > 25) {
            item.title = item.title.slice(0, 25)
          }

          const index = arr.findIndex((option) => {
            return option.originalText == item.title
          })

          if (index === -1) {
            const word = {
              text: this.$store.state.presentation.filteringProfanity && item.title
                ? filterProfaneWords(item.title)
                : item.title,
              originalText: item.title,
              count: 1,
              length: item.title.length,
            }
            arr.push(word)
          } else {
            arr[index].count++
          }
        }
      })
      arr = arr.sort((a, b) => {
        return b.count - a.count
      })

      if (arr.length) {
        let total = 0
        const pool = 15000
        // let offSet;
        arr.forEach((item) => {
          total += item.count
        })

        // function getFontSize(x) {

        //   let y = 1.5 * Math.pow(x, 1 / 3);
        //   return y;
        // }

        arr.forEach((item, key) => {
          item.percent = (item.count / total) * 100
          // offSet = getFontSize(arr.length);

          item.size = Math.sqrt((pool / 100) * item.percent)

          if (item.size > 90) {
            item.size = 90
          } else if (item.size < 16) {
            item.size = 16
          }
          let indexColor = key
          if (key > 29) {
            indexColor = key - parseInt(key / 29, 10) * 29
          }
          if (this.$store.state.slideActive.textColour == '#ffffff') {
            item.color = Constant.lighterColors[indexColor]
          } else {
            item.color = Constant.colors[indexColor]
          }
        })

        if (arr.length) {
          arr[0].isMax = true
        }
      }
      return arr
    },
    renderWordCloud() {
      const self = this
      const { d3 } = window
      if (document.getElementById('word-cloud')) {
        document.getElementById('word-cloud').innerHTML = ''
      }
      Util.disallowPDFRender()

      // Simple animated example of d3-cloud - https://github.com/jasondavies/d3-cloud
      // Based on https://github.com/jasondavies/d3-cloud/blob/master/examples/simple.html

      // Encapsulate the word cloud functionality

      // Encapsulate the word cloud functionality
      function wordCloud(selector) {
        // Construct the word cloud's SVG element
        const svg = d3
          .select(selector)
          .append('svg')
          .attr('width', 1180)
          .attr('height', 480)
          .append('g')
          .attr('transform', 'translate(590,240)')

        // Draw the word cloud
        function draw(words) {
          // AHA-3873: add 'waiting' class for PDF export worker to wait
          // until the rendering process is finished

          const cloud = svg.selectAll('g text').data(words, (d) => {
            return d.originalText
          })

          // Entering words
          cloud
            .enter()
            .append('text')
            .style('font-family', "'Nunito', sans-serif")
            .style('font-weight', 'bold')
            .style('fill', (d) => {
              return d.color
            })
            .attr('text-anchor', 'middle')
            .attr('font-size', 1)
            .text((d) => {
              return d.text
            })
            .on('click', (d) => {
              if (self.$store.state.sharePresentation || self.isBackstage) return
              const textIndex = words.findIndex((item) => {
                return item.originalText === d.originalText
              })
              const textRemove = words[textIndex].originalText
              const options = JSON.parse(JSON.stringify(self.$store.state.slideActive.SlideOptions))
              options.forEach((item) => {
                if (item.title) {
                  item.title = item.title.trim()
                  item.title = item.title.toLowerCase()
                  if (item.title.length > 25) {
                    item.title = item.title.slice(0, 25)
                  }
                }
              })
              const arr = []
              options.forEach((data, key) => {
                if (data.title != textRemove) {
                  arr.push(self.$store.state.slideActive.SlideOptions[key])
                }
              })
              self.updateSlideActiveAction({
                SlideOptions: arr,
              })
              if (arr.length === 0) {
                PresentationUtils.checkAndUpdatePresentationHasResults()
              }
              self.myWordCloud.update(self.getWords())

              self.$http.post(Config.api.removeWordCloud, {
                slideId: self.$store.state.slideActive.id,
                presentationId: self.$store.state.presentation.id,
                text: textRemove,
              }).then(() => {
                Util.gaTrackEvent(
                  'Slide type',
                  'Word Cloud Remove',
                  'Presenter remove word',
                )
              })
            })

          // Entering and existing words
          cloud
            .transition()
            .duration(WORD_CLOUD_TRANSITION_DURATION)
            .style('font-size', (d) => {
              return `${d.size}px`
            })

            .attr('transform', (d) => {
              return `translate(${[d.x, d.y]})rotate(${d.rotate})`
            })
            .style('fill-opacity', 1)

          // Exiting words
          cloud
            .exit()
            .transition()
            .duration(200)
            .style('fill-opacity', 1e-6)
            .attr('font-size', 1)
            .remove()

          setTimeout(() => {
            Util.allowPDFRender()
          }, 2000)
        }

        // Use the module pattern to encapsulate the visualisation code. We'll
        // expose only the parts that need to be public.
        return {
          // Recompute the word cloud for a new set of words. This method will
          // asycnhronously call draw when the layout has been computed.
          // The outside world will need to call this function, so make it part
          // of the wordCloud return value.
          update(words) {
            d3.layout
              .cloud()
              .size([1180, 480])
              .words(words)
              .padding(4)
              .rotate((d) => {
                if (d.isMax || d.text.length > 18 || d.size > 50) {
                  return 0
                }

                return ~~(Math.random() * 2) * 270
              })
              .font("'Nunito', sans-serif")
              .fontSize((d) => {
                return d.size
              })
              .on('end', draw)
              .start()
          },
        }
      }

      // Some sample data - http://en.wikiquote.org/wiki/Opening_lines

      // Prepare one of the sample sentences by removing punctuation,
      // creating an array of words and computing a random size attribute.

      // This method tells the word cloud to redraw with a new set of words.
      // In reality the new words would probably come from a server request,
      // user input or some other source.
      function showNewWords(vis) {
        vis.update(self.getWords())
      }

      // Create a new instance of the word cloud visualisation.
      self.myWordCloud = wordCloud('#word-cloud')

      // Start cycling through the demo data
      showNewWords(self.myWordCloud)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.content-wrapper {
  width: 100%;
  height: 100%;
  &.cross-content {
    &::v-deep text:hover {
      text-decoration: line-through;
      cursor: pointer;
    }
  }
}
</style>
